import BPIcon, { icons } from 'components/BionicUI/icons/BPIcon';
import BPIconBorder from 'components/BionicUI/icons/BPIconBorder';
import BPSpinner from 'components/BionicUI/loading/BPSpinner';
import { cn } from 'lib/utils';
import { FC, useEffect, useState } from 'react';

interface CardIconProps {
  icon?: keyof typeof icons;
  iconImageUrl?: string;
  animate?: boolean;
  onIconAnimationComplete?: () => void;
  forceFullSize?: boolean;
}

const CardIcon: FC<CardIconProps> = ({
  icon = undefined,
  iconImageUrl = undefined,
  animate = true,
  onIconAnimationComplete = () => {},
  forceFullSize = false,
}) => (
  <div
    className={cn(
      'grid relative justify-center items-center fill-white bg-white/5 rounded-[8px] overflow-hidden',
      forceFullSize
        ? 'w-[56px] h-[56px]'
        : 'w-[40px] h-[40px] @sm:w-[42px] @sm:h-[42px] @md:w-[46px] @md:h-[46px] @lg:w-[50px] @lg:h-[50px] @xl:w-[56px] @xl:h-[56px]'
    )}
  >
    {iconImageUrl ? (
      <IconImage url={iconImageUrl} />
    ) : (
      icon && (
        <BPIcon
          icon={icon}
          className={cn(
            forceFullSize
              ? 'scale-[1.4]'
              : 'scale-[0.85] @sm:scale-[1] @md:scale-[1.2] @lg:scale-[1.25] @xl:scale-[1.4]'
          )}
        />
      )
    )}
    <BPIconBorder animate={animate} onAnimComplete={onIconAnimationComplete} />
  </div>
);

const IconImage: FC<{ url: string }> = ({ url }) => {
  const [srcUrl, setSrcUrl] = useState<string | null>(null);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setSrcUrl(url);
    img.src = url;
  }, []);

  return (
    <>
      {srcUrl ? (
        <img
          src={url}
          alt="icon"
          className="block relative w-full h-full object-cover animate-fade-in"
        />
      ) : (
        <div className="grid relative w-full h-full justify-center items-center">
          <BPSpinner width={24} />
        </div>
      )}
    </>
  );
};

export default CardIcon;
